var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFaceGrinHeartsSolid1({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8_1526)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25 50C31.6304 50 37.9893 47.3661 42.6777 42.6777C47.3661 37.9893 50 31.6304 50 25C50 18.3696 47.3661 12.0107 42.6777 7.32233C37.9893 2.63392 31.6304 0 25 0C18.3696 0 12.0107 2.63392 7.32233 7.32233C2.63392 12.0107 0 18.3696 0 25C0 31.6304 2.63392 37.9893 7.32233 42.6777C12.0107 47.3661 18.3696 50 25 50ZM37.9004 30.5469C39.1016 30.1758 40.2734 31.2207 39.7852 32.373C37.3438 38.1445 31.6602 42.1875 25.0293 42.1875C18.3984 42.1875 12.7051 38.1445 10.2734 32.373C9.78516 31.2207 10.957 30.1758 12.1582 30.5469C16.0352 31.7383 20.4102 32.4023 25.0293 32.4023C29.6484 32.4023 34.0234 31.7383 37.9004 30.5469ZM19.4629 12.6074C21.2012 13.0762 22.2363 14.8633 21.7676 16.5918L20.0684 22.9395C19.8438 23.7695 18.9844 24.2676 18.1543 24.043L11.7969 22.3438C10.0586 21.875 9.02344 20.0879 9.49219 18.3594C9.96094 16.6309 11.748 15.5859 13.4766 16.0547L15.0488 16.4746L15.4687 14.9023C15.9375 13.1641 17.7246 12.1289 19.4531 12.5977L19.4629 12.6074ZM34.5312 14.9121L34.9512 16.4844L36.5234 16.0645C38.2617 15.5957 40.0488 16.6309 40.5078 18.3691C40.9668 20.1074 39.9414 21.8945 38.2031 22.3535L31.8457 24.0527C31.0156 24.2773 30.1562 23.7793 29.9316 22.9492L28.2324 16.6016C27.7637 14.8633 28.7988 13.0762 30.5371 12.6172C32.2754 12.1582 34.0625 13.1836 34.5312 14.9219V14.9121Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8_1526"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "black"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaceGrinHeartsSolid1);
export default __webpack_public_path__ + "static/media/face-grin-hearts-solid 1.d6ae7828c8bb1c56427e854e1092dcea.svg";
export { ForwardRef as ReactComponent };